<template>
  <v-col class="pa-0 fill-height">
    <v-toolbar dense flat>
      <v-toolbar-title>{{
        $t("consumption-accounting.consumption-accounting")
      }}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-col class="py-0">
      <ConsumptionAccountingComponent></ConsumptionAccountingComponent>
    </v-col>
  </v-col>
</template>

<script>
import { projectTitle } from "../../../components/mixins/projects/projectTitle";
import ConsumptionAccountingComponent from "../../../components/projects/accounting/documents/ConsumptionAccounting";
export default {
  name: "ConsumptionAccounting",
  mixins: [projectTitle],
  components: {
    ConsumptionAccountingComponent
  },
  props: ["project_id", "type"],
  methods: {
    getArgumentForTitle() {
      return {
        chain: [this.$t("consumption-accounting.consumption-accounting")]
      };
    }
  }
};
</script>
<style scoped>
.fill-height {
  min-height: calc(100vh - 68px);
}
</style>
